export const SET_GLOBAL_LOADER_STATE = "SET_GLOBAL_LOADER_STATE";
export const SET_CURRENT_VIEW = "SET_CURRENT_VIEW";
export const SET_BROWSER_INCOMPATIBLE = "SET_BROWSER_INCOMPATIBLE";
